let sequence = 0;

/**
 * A document-unique id for ARIA relationships (a combobox and its listbox,
 * a label and its input). Module-scoped, so every component instance gets
 * its own even when several are mounted at once.
 */
export function nextDomId(prefix: string): string {
  sequence += 1;
  return `${prefix}-${sequence}`;
}
